export default __webpack_public_path__ + "static/media/two_tou5.079c9fec.png";